import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const deleteActions = createActionGroup({
  source: 'Einreichung - file delete',
  events: {
    'Clear store': emptyProps(),
    'Delete request': props<{ fileId: string }>(),
    'Delete started': emptyProps(),
    'Delete failure': props<{ error: string }>(),
    'Delete completed': emptyProps(),
  },
});
